import { yupResolver } from '@hookform/resolvers/yup';

import yup, { ErrorLengthMax, ErrorLengthMin, ERROR_REQUIRED } from 'utils/yup-form-validator';

const schema = yup.object({
  displayName: yup.string()
    .min(3, ErrorLengthMin(3))
    .max(50, ErrorLengthMax(50))
    .isAlphanumericHypenBracketSpace()
    .required(ERROR_REQUIRED),
  description: yup.string().max(128, ErrorLengthMax(128)),
  deviceLimit: yup.string().isNumeric().isInt().required(ERROR_REQUIRED),
  poolLimit: yup.string().isNumeric().isInt(),
  sourceLimit: yup.string().isNumeric().isInt(),
  enableEncryption: yup.boolean(),
  xxteaKeyToken: yup.string()
    .when('enableEncryption', {
      is: true,
      then: yup.string().isJWT().required(),
    }),
});

const validator = yupResolver(schema);

export default validator;
